/**
 * convertCamelCaseToSnakeCase converts a camel case string to snake case
 * @param {string} camelCaseString A string in camel case.
 * @returns A string in snake case.
 * @example
 *
 *   convertCamelCaseToSnakeCase('marketingCarrierCode');
 *   // returns 'marketing_carrier_code'
 */
export const convertCamelCaseToSnakeCase = (camelCaseString: string): string => {
  const LOWER_CASE_UPPER_CASE_DUPLE = /([a-z])([A-Z])/g;

  return camelCaseString.replace(LOWER_CASE_UPPER_CASE_DUPLE, "$1_$2").toLowerCase();
};
